module.exports = __webpack_public_path__ + "prod/1.42.2/img/superiority7.d263a852.png";